import { Component, OnInit } from '@angular/core';
import { NodeService } from '../../shared/services/nodeservice.service';
import { Downloads } from '../../shared/services/downloads';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html'
})
export class DownloadsComponent implements OnInit {

    loading: boolean;
    files1: Downloads[];
    selectedNode1: Downloads;

    cols: any[];

    constructor(private nodeService: NodeService) { }

    ngOnInit() {

        this.loading = true;
        this.nodeService.getDownloads().then(files => this.files1 = files);

        this.cols = [
            { field: 'submittedDate', header: 'Submitted Date' },
            { field: 'applicationNo', header: 'Application No.' },
            { field: 'applicantName', header: 'Applicant Name' },
            { field: 'srnHin', header: 'SRN / HIN' },
            { field: 'emailAddress', header: 'Email Address' },
            { field: 'dateOfBirth', header: 'Date of Birth' },
            { field: 'policyAccountNumber', header: 'Policy / Account Number' },
            { field: 'numberOfShares', header: 'Number Of Shares' }
        ];
    }

}
